export default "__VITE_ASSET__NlKlUILc__"